import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { Card, Col, Container, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import * as yup from "yup";
import { getMethod, postRequestByAuth } from "../../../function/helper";
import Loading from "../../../modules/pages/newLetter/Loader";
import FooterPostup from "../../../modules/public/footer/footer";
import Menu from "../../../modules/public/menu/menu";
import useSharedData from "../../../hooks/useSharedData";
const schema = yup
  .object({
    cityId: yup.number().required(),
    address: yup.string().required(),
    major: yup.string().required(),
    tel: yup.string().required(),
  })
  .required();

const AgentRequestF = () => {
  const { user } = useSharedData();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const [name, setName] = useState("");
  const [family, setFamily] = useState("");
  const [phone, setPhone] = useState("");
  const [nationalCode, setNationalCode] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("مرد");
  const [address, setAddress] = useState("");
  const [major, setMajor] = useState("");
  const [military, setMilitary] = useState("");
  const [degree, setDegree] = useState("دیپلم");
  const [tel, setTel] = useState("");
  const [married, setMarried] = useState("مجرد");
  const [age, setAge] = useState("کمتر از 25 سال");
  const [havingOffice, setHavingOffice] = useState("بله");
  const [relatedExperience, setRelatedExperience] = useState("");
  const [guaranty, setGuaranty] = useState("بله");
  const [canPayWarranty, setCanPayWarranty] = useState(1);
  const [equipAbility, setEquipAbility] = useState("بله");
  const [salaryAbility, setSalaryAbility] = useState("بله");
  const [description, setDescription] = useState("");
  const [acquaintance, setAcquaintance] = useState("سایت");
  const [province, setProvince] = useState([]);
  const [provinceId, setProvinceId] = useState("");
  const [city, setCity] = useState([]);
  const [cityId, setCityId] = useState("");
  const canUpdate = false;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getProvinces();
    if (user) {
      setName(user.name);
      setFamily(user.family);
      setPhone(user.phone);
      setNationalCode(user.nationalCode);
      setEmail(user.email);
    }
  }, []);

  const getProvinces = async () => {
    const province = await getMethod("/address/v1/province/show/1");
    setProvince(province.data);
  };

  const getCity = async id => {
    const city = await getMethod("/address/v1/city/show/" + id);
    setCity(city.data);
    setProvinceId(id);
  };

  const sendValue = async () => {
    const body = {
      nationalCode: nationalCode,
      name: name,
      family: family,
      phone: phone,
      email: email,
      address: address,
      major: major,
      tel: tel,
      married: married,
      age: age,
      havingOffice: havingOffice,
      relatedExperience: relatedExperience,
      equipAbility: equipAbility,
      salaryAbility: salaryAbility,
      description: description,
      acquaintance: acquaintance,
      provinceId: provinceId,
      cityId: cityId,
      degree: degree,
      military: military,
      canUpdate: canUpdate,
      guaranty,
      canPayWarranty,
    };
    setLoading(true);
    const response = await postRequestByAuth("/agent/v1/add", body);
    setLoading(false);
    if (response.status === 200) {
      Swal.fire({
        icon: "success",
        text: response.data.data,
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
    } else {
      Swal.fire({
        icon: "error",
        text: response.data.data,
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
    }
  };

  return (
    <div>
      <Menu />
      <Container className="mt-5">
        <div className="loginFormCol">
          <Card className="loginForm">
            <Form onSubmit={handleSubmit(sendValue)}>
              <Row xl={12} lg={12} md={12} xs={12} className="sender">
                <p className="title-style">فرم ثبت درخواست اخذ نمایندگی</p>
                <hr className="style1" />
                <Col xl={4} lg={4} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>کدملی</Form.Label>
                    <Form.Control
                      type="number"
                      readOnly
                      value={nationalCode}
                      name="nationalCode"
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>شماره موبایل</Form.Label>
                    <Form.Control
                      type="number"
                      value={phone}
                      name="phone"
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>ایمیل</Form.Label>
                    <Form.Control
                      type="email"
                      value={email}
                      name="email"
                      onChange={e => setEmail(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>نام</Form.Label>
                    <Form.Control
                      type="text"
                      value={name}
                      name="name"
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>نام خانوادگی</Form.Label>
                    <Form.Control
                      type="text"
                      value={family}
                      name="family"
                      readOnly
                    />
                  </Form.Group>
                </Col>
                <Col xl={4} lg={4} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>جنسیت</Form.Label>
                    <Form.Select
                      type="text"
                      value={gender}
                      name="gender"
                      onChange={e => setGender(e.target.value)}
                    >
                      <option value="زن">زن</option>
                      <option value="مرد">مرد</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={6} lg={6} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>استان را انتخاب کنید</Form.Label>
                    <Form.Select
                      style={
                        errors.provinceId && {
                          boxShadow: "0px 0px 10px #ff0000",
                        }
                      }
                      onChange={e => getCity(e.target.value)}
                      name="provinceId"
                      defaultValue={0}
                    >
                      <option value={0}>...</option>
                      {province.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.faName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  {errors.provinceId && (
                    <span style={{ color: "red" }}>این فیلد اجباری است</span>
                  )}
                </Col>
                <Col xl={6} lg={6} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>شهر را انتخاب کنید</Form.Label>
                    <Form.Select
                      name="cityId"
                      {...register("cityId")}
                      style={
                        errors.cityId && {
                          boxShadow: "0px 0px 10px #ff0000",
                        }
                      }
                      onChange={e => setCityId(e.target.value)}
                      defaultValue={0}
                    >
                      <option value={0}>...</option>
                      {city.map((item, index) => (
                        <option value={item.id} key={index}>
                          {item.faName}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                  {errors.cityId && (
                    <span style={{ color: "red" }}>این فیلد اجباری است</span>
                  )}
                </Col>
                <Col xl={12} lg={12} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>آدرس</Form.Label>
                    <Form.Control
                      type="text"
                      name="address"
                      style={
                        errors.address && {
                          boxShadow: "0px 0px 10px #ff0000",
                        }
                      }
                      {...register("address")}
                      aria-invalid={errors.address ? "true" : "false"}
                      value={address}
                      onChange={e => setAddress(e.target.value)}
                    />
                  </Form.Group>
                  {errors.address && (
                    <span style={{ color: "red" }}>این فیلد اجباری است</span>
                  )}
                </Col>
                <Col xl={6} lg={6} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>تحصیلات</Form.Label>
                    <Form.Select
                      name="degree"
                      onChange={e => setDegree(e.target.value)}
                    >
                      <option value="دیپلم">دیپلم</option>
                      <option value="فوق دیپلم">فوق دیپلم</option>
                      <option value="لیسانس">لیسانس</option>
                      <option value="فوق لیسانس">فوق لیسانس</option>
                      <option value="دکتری و بالاتر">دکتری و بالاتر</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={6} lg={6} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>رشته تحصیلی</Form.Label>
                    <Form.Control
                      type="text"
                      style={
                        errors.major && {
                          boxShadow: "0px 0px 10px #ff0000",
                        }
                      }
                      {...register("major")}
                      name="major"
                      value={major}
                      onChange={e => setMajor(e.target.value)}
                    />
                  </Form.Group>
                  {errors.major && (
                    <span style={{ color: "red" }}>این فیلد اجباری است</span>
                  )}
                </Col>
                <Col xl={6} lg={6} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>وضعیت نظام وظیفه</Form.Label>
                    <Form.Select
                      name="military"
                      onChange={e => setMilitary(e.target.value)}
                    >
                      <option value="بانو هستم">بانو هستم</option>
                      <option value="مشمول">مشمول</option>
                      <option value="معاف">معاف</option>
                      <option value="دارای کارت پایان خدمت">
                        دارای کارت پایان خدمت
                      </option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={6} lg={6} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>تلفن</Form.Label>
                    <Form.Control
                      type="number"
                      name="tel"
                      style={
                        errors.tel && { boxShadow: "0px 0px 10px #ff0000" }
                      }
                      {...register("tel")}
                      value={tel}
                      onChange={e => setTel(e.target.value)}
                    />
                  </Form.Group>
                  {errors.tel && (
                    <span style={{ color: "red" }}>این فیلد اجباری است</span>
                  )}
                </Col>
                <Col xl={6} lg={6} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>وضعیت تاهل</Form.Label>
                    <Form.Select
                      name="married"
                      onChange={e => setMarried(e.target.value)}
                    >
                      <option value="مجرد">مجرد</option>
                      <option value="متاهل">متاهل</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={6} lg={6} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>سن</Form.Label>
                    <Form.Select
                      name="age"
                      onChange={e => setAge(e.target.value)}
                    >
                      <option value="کمتر از 25 سال ">کمتر از 25 سال </option>
                      <option value="بین 25 تا 30 سال">بین 25 تا 30 سال</option>
                      <option value="بین 30 تا 45 سال">بین 30 تا 45 سال</option>
                      <option value="بالای 45 سال">بالای 45 سال</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={6} lg={6} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>دسترسی به فضای دفتر کاری</Form.Label>
                    <Form.Select
                      name="havingOffice"
                      onChange={e => setHavingOffice(e.target.value)}
                    >
                      <option value="بله">بله </option>
                      <option value="خیر">خیر</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col xl={6} lg={6} md={12} xs={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>نحوه آشنایی</Form.Label>
                    <Form.Select
                      name="acquaintance"
                      onChange={e => setAcquaintance(e.target.value)}
                    >
                      <option value="سایت آواکس">سایت آواکس</option>
                      <option value="دیوار">دیوار</option>
                      <option value="دوستان">دوستان</option>
                      <option value="نماینده یاب">نماینده یاب</option>
                      <option value="شبکه های اجتماعی">شبکه های اجتماعی</option>
                      <option value="سایت های خبری">سایت های خبری</option>
                      <option value="سایر">سایر</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Form.Group xl={2} lg={2} md={2} xs={1} className="mb-3">
                  <Form.Label>
                    آیا توان پرداخت مبلغ 25 میلیون تومان به‌عنوان وجه الضمان
                    مفاصا حساب (دارایی،شهرداری،تامین اجتماعی) که نزد شرکت بصورت
                    امانت تا پایان قرارداد می‌ماند، را در بدو عقد قرارداد دارید؟
                  </Form.Label>
                  <Form.Select
                    onChange={e => setCanPayWarranty(parseInt(e.target.value))}
                    defaultValue={canPayWarranty}
                  >
                    <option value={1}>بله</option>
                    <option value={0}>خیر</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group xl={2} lg={2} md={2} xs={1} className="mb-3">
                  <Form.Label>
                    آیا امکان تامین ضمانت مورد نیاز &#34;چک صیادی به مبلغ 500
                    میلیون تومان&#34; را دارید؟
                  </Form.Label>
                  <Form.Select
                    name="guaranty"
                    onChange={e => setGuaranty(e.target.value)}
                  >
                    <option value="بله">بله</option>
                    <option value="خیر">خیر</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group xl={2} lg={2} md={2} xs={1} className="mb-3">
                  <Form.Label>
                    آیا توان تجهیز نمایندگی تا ۳۵ میلیون تومان را دارید؟
                  </Form.Label>
                  <Form.Select
                    name="equipAbility"
                    onChange={e => setEquipAbility(e.target.value)}
                  >
                    <option value="بله">بله </option>
                    <option value="خیر">خیر</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group xl={2} lg={2} md={2} xs={1} className="mb-3">
                  <Form.Label>
                    آیا توان پرداخت حقوق و حق بیمه کارکنان خود را دارید؟
                  </Form.Label>
                  <Form.Select
                    name="salaryAbility"
                    onChange={e => setSalaryAbility(e.target.value)}
                  >
                    <option value="بله">بله </option>
                    <option value="خیر">خیر</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group xl={2} lg={2} md={2} xs={1} className="mb-3">
                  <Form.Label>سوابق پستی دارید؟ توضیح دهید</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="relatedExperience"
                    value={relatedExperience}
                    onChange={e => setRelatedExperience(e.target.value)}
                  />
                </Form.Group>

                <Form.Group xl={2} lg={2} md={2} xs={1} className="mb-3">
                  <Form.Label>توضیحات</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="description"
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                  />
                </Form.Group>
              </Row>

              <hr />

              <div className="text-center">
                {loading ? (
                  <Loading />
                ) : (
                  <button className="btn-success-style" type="submit">
                    ارسال
                  </button>
                )}
              </div>
            </Form>
          </Card>
        </div>
      </Container>
      <FooterPostup />
    </div>
  );
};

export default AgentRequestF;
